import config from 'config';
import { DAYS } from './parseToStreamsetsService';
import { insert } from 'utils/string';

const parseFromPelias = (data, gid) => {
  if (!data || !gid) {
    return data;
  }

  const [venueFeature] = data?.features || [];

  if (!venueFeature) {
    return undefined;
  }

  const venueName = venueFeature?.properties?.name;
  const venueRegion = venueFeature?.properties?.region;

  const [lng, lat] = venueFeature?.geometry?.coordinates || [];

  const addendum = venueFeature?.properties?.addendum;

  const acceptedVehicles = addendum?.accepted_vehicles?.accepted_vehicles || [];

  const booking = addendum?.is_booking_required
    ? {
        isRequired: addendum?.is_booking_required?.is_booking_required,
        instructions: addendum?.is_booking_required?.instructions,
      }
    : undefined;

  const driverInstructions = addendum?.driver_instructions?.driver_instructions || '';
  const internalInstructions = addendum?.other_data?.internal_instructions || '';
  const contacts = addendum?.contacts?.contacts || [];
  const vehicleRequirements = addendum?.vehicle_requirements || {};
  const sourceVersion = addendum?.load_info?.source_version;
  const sourceOrigin = addendum?.load_info?.source_origin;

  const defaultTimeFrames = addendum?.timeframes?.default;
  const openingHoursSchedules = parseOpeningHours(addendum?.timeframes?.default);

  const sourceURL = `${config.POI_SERVICE_URL}place/?ids=${gid}`;

  return {
    venueName,
    venueRegion,
    position: {
      lat: lat,
      lng: lng,
    },
    acceptedVehicles,
    booking,
    driverInstructions,
    internalInstructions,
    vehicleRequirements,
    contacts,
    sourceVersion,
    sourceOrigin,
    sourceURL,
    defaultTimeFrames,
    openingHoursSchedules,
  };
};

/**
 * We parse the data for react forms:
 *
 * [
 *  {
 *    schedule_days: [
 *      selected: true,
 *      selected: false,
 *      ...
 *    ],
 *    schedule_ranges: [
 *      {
 *        from: "00:00",
 *        to: "08:00",
 *      },
 *      ...
 *    ]
 *  }
 *  ...
 * ]
 */
const parseOpeningHours = (timeFrames = {}) => {
  return Object.entries(timeFrames)
    .reduce((current, [day, ranges]) => {
      if (ranges?.length <= 0) {
        return current;
      }

      // Get the day index (0 - 6) according to the name
      const dayIndex = Object.values(DAYS).indexOf(day);

      // Get a schedule that has the same range in order to set the day as selected
      const schedule = current.find(({ schedule_ranges }) =>
        schedule_ranges.some(({ from, to }) =>
          ranges.some((range) => range.from === from && range.to === to)
        )
      );

      if (schedule) {
        schedule.schedule_days[dayIndex].selected = true;
        return current;
      }

      return [
        ...current,
        {
          schedule_days: Array.from(Array(7).keys()).map((i) => ({ selected: i === dayIndex })),
          schedule_ranges: ranges,
        },
      ];
    }, [])
    .map((schedule) => ({
      ...schedule,
      schedule_ranges: schedule.schedule_ranges.map((range) => ({
        from: insert(range.from, 2, ':'),
        to: insert(range.to, 2, ':'),
      })),
    }));
};

export default parseFromPelias;
